import React, { useState, useEffect } from 'react';

const Districtcommitie = () => {
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [districtMembers, setDistrictMembers] = useState([]);
  const [allDistrictMembers, setAllDistrictMembers] = useState([]);

  const districts = [
    "Srikakulam", "Vizianagram", "Visakhapatnam", "Kakinada",
    "East Godavari", "Konaseema", "West Godavari", "Eluru",
    "Vijayawada", "Krishna", "Guntur", "Palnadu", "Bapatla",
    "Prakasam", "Nellore", "Nandayala", "Kurnool", "Anantapur",
    "Sri Sathyasai", "Kadapa", "Annamayya", "Tirupati", "Chittoor"
  ];

  const designationOrder = ["President", "Secretary", "Treasurer"];

  const designationColors = {
    President: { badge: "bg-emerald-500", dot: "bg-emerald-500" },
    Secretary: { badge: "bg-emerald-500", dot: "bg-emerald-500" },
    Treasurer: { badge: "bg-emerald-500", dot: "bg-emerald-500" }
  };

  useEffect(() => {
    setAllDistrictMembers([
      { district: "Srikakulam", name: "SHAYKH MOHAMMED SHAKIR SALAFI", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Srikakulam", name: "SHAYKH ANEES UMRI", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Srikakulam", name: "JANAB MOHAMMED AMEEN SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Vizianagram", name: "JANAB SULAIMAN SAHEB", designation: "President", image: "/images/muslimlogo.jpg" },

      { district: "Visakhapatnam", name: "SHAYKH MOHAMMED HASSAN OMRI", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Visakhapatnam", name: "JANAB ATHAR HUSSAIN SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Visakhapatnam", name: "MOHAMMED ZIAULLAH", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Kakinada", name: "JANAB PATHAN MOHAMMED RASOOL KHAN", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Kakinada", name: "JANAB SAYYED ABDUR RAHMAN SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Kakinada", name: "JANAB TAJUDDIN SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "East Godavari", name: "JANAB MOHAMMED NAUSHAD SAHEB", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "East Godavari", name: "JANAB ABDUL MANNAN SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "East Godavari", name: "JANAB MOHAMMED RAFI SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "West Godavari", name: "SHAYKH HAFIZ KHALEEL UR RAHMAN", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "West Godavari", name: "SHAYKH ALTAF UR RAHMAN OMRI", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "West Godavari", name: "SHAYKH ASIF JAMAI", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Eluru", name: "SHAYKH ABUBAKAR BAIG OMRI", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Eluru", name: "SHAYKH ZAKIR HUSSAIN JAMAI", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Eluru", name: "JANAB SAYYED KAREEMUDDIN SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Vijayawada", name: "SHAYKH NASEER AHMED OMRI", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Vijayawada", name: "JANAB SAYYED ATEEQ UR RAHMAN SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Vijayawada", name: "JANAB RIZWANULLAH QURESHI SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Krishna", name: "JANAB SAYKH AHMED SAHEB", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Krishna", name: "SHAYKH INAMULLAH OMRI", designation: "Secretary", image: "/images/muslimlogo.jpg" },

      { district: "Guntur", name: "JANAB ABDUR RAHMAN SAHEB", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Guntur", name: "JANAB ABDUL KAREEM SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Guntur", name: "JANAB MAULALI SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Palnadu", name: "JANAB SULAIMAN BABU SAHEB", designation: "President", image: "/images/muslimlogo.jpg" },

      { district: "Bapatla", name: "JANAB SHAYKH AHMED SAHEB", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Bapatla", name: "JANAB ISMAIL SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Bapatla", name: "JANAB SHAYKH ISMAIL SHAEB (VALAPARLA)", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Prakasam", name: "JANAB SHAYKH VAJID AHMED SAHEB", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Prakasam", name: "JANAB SHAYKH NAGOR VALI SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Prakasam", name: "JANAB SHAYKH MAHBOOB JAN SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Nellore", name: "JANAB ABDUL KAREEM SAHEB", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Nellore", name: "JANAB SHYKH FAROOQ SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Nellore", name: "JANAB ABDUL HAFEEZ SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Nandayala", name: "SHAYKH RAHMATULLAH OMRI", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Nandayala", name: "SHAYKH D ZIA UR RAHMAN OMRI", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Nandayala", name: "JANAB SAYYED IQBAL HUSAIN", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Kurnool", name: "SHAYKH JAMALUDDIN SAHAEB", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Kurnool", name: "JANAB IRFAN SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Anantapur", name: "SHAYKH ABDUL AZEEM JAMAI", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Anantapur", name: "SHAYKH HAFIZ MOHAMMED AMEEN OMRI MADNI", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Anantapur", name: "JANAB BASHA SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Sri Sathyasai", name: "SHAYKH T USMAN GHANI SANABILI SAHEB", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Sri Sathyasai", name: "B ABDUL HAMEED HAMDAM SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Sri Sathyasai", name: "JANAB ADAM ISMAIL SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Kadapa", name: "SHAYKH BSHEER AHMED JAMAI", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Kadapa", name: "JANAB MASTAN SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Kadapa", name: "JANAB ABDULLAH SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Annamayya", name: "SHAYKH ZAFRULLAH JAMAI NADVI", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Annamayya", name: "JANAB JAHANGIR SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Annamayya", name: "SHAYKH NOOR AHMED JAMAI", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Tirupati", name: "JANAB MAHBOOB SAHEB", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Tirupati", name: "JANAB NOOR MOHAMMED SAHEB", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Tirupati", name: "JANAB ABDUR RASHEED SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },

      { district: "Chittoor", name: "SHAYKH HAFIZ AZMATULLAH OMRI", designation: "President", image: "/images/muslimlogo.jpg" },
      { district: "Chittoor", name: "SHAYKH ASIF OMRI", designation: "Secretary", image: "/images/muslimlogo.jpg" },
      { district: "Chittoor", name: "JANAB MASTAN SAHEB", designation: "Treasurer", image: "/images/muslimlogo.jpg" },
    ]);
  }, []);

  const handleDistrictChange = (e) => {
    const district = e.target.value;
    setSelectedDistrict(district);
    const members = allDistrictMembers.filter((member) => member.district === district);
    setDistrictMembers(members);
  };

  const normalizeDesignation = (designation) => {
    if (!designation) return 'Member';
    const normalized = designation.trim().toLowerCase();
    switch (normalized) {
      case 'president': return 'President';
      case 'secretary': return 'Secretary';
      case 'treasurer': return 'Treasurer';
      default: return 'Member';
    }
  };

  const sortByDesignationOrder = (members) => {
    return [...members].sort((a, b) => {
      const aDesignation = normalizeDesignation(a.designation);
      const bDesignation = normalizeDesignation(b.designation);
      return designationOrder.indexOf(aDesignation) - designationOrder.indexOf(bDesignation);
    });
  };

  const categorizeMembers = (members) => {
    const categories = { President: [], Secretary: [], Treasurer: [] };
    members.forEach((member) => {
      const designation = normalizeDesignation(member.designation);
      if (categories[designation]) {
        categories[designation].push(member);
      }
    });
    return categories;
  };

  const sortedDistrictMembers = sortByDesignationOrder(districtMembers);
  const districtCategories = categorizeMembers(sortedDistrictMembers);

  return (
    <div className='min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50/30'>
      {/* Hero Section */}
      <section className="relative w-full h-[55vh] md:h-[75vh] overflow-hidden">
        <img src="/images/mosque4.jpg" alt="Mosque" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60 z-10"></div>
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center px-4 sm:px-6">
          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black mb-4 tracking-tight uppercase">
            District Committee
          </h1>
          <div className="w-20 sm:w-24 h-1 bg-black/90 mb-4 sm:mb-6"></div>
          <p className="text-gray-50 max-w-2xl text-sm sm:text-base md:text-lg font-light leading-relaxed">
            Meet our dedicated leaders serving the community with excellence
          </p>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-12 sm:py-16 md:py-20">

        {/* District Selector */}
        <div className="mb-12 sm:mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 md:p-10 border border-gray-100">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8">
              <div className="text-center md:text-left">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-black text-gray-800 mb-2 uppercase">
                  Select District
                </h2>
                <p className="text-gray-600 text-xs sm:text-sm font-light">Choose a district to view committee members</p>
              </div>
              <div className="w-full md:w-auto md:min-w-[280px] lg:min-w-[320px]">
                <select
                  value={selectedDistrict}
                  onChange={handleDistrictChange}
                  className="w-full px-4 sm:px-6 py-3 sm:py-3.5 rounded-xl font-black text-sm sm:text-base text-gray-700 bg-gray-50
                             border-2 border-gray-200 shadow-sm appearance-none cursor-pointer
                             hover:border-gray-400 focus:outline-none focus:border-gray-500
                             focus:ring-4 focus:ring-gray-100 transition-all duration-200"
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23059669'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 1rem center',
                    backgroundSize: '1.25em 1.25em',
                    paddingRight: '3rem'
                  }}
                >
                  <option value="">Choose District</option>
                  {districts.map((district) => (
                    <option key={district} value={district}>{district}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Committee Members Grid */}
        {selectedDistrict && sortedDistrictMembers.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 md:gap-10 pb-60 sm:pb-80">
            {designationOrder.map((designation) => {
              const members = districtCategories[designation];
              if (!members || members.length === 0) return null;
              return members.map((member, idx) => (
                <div key={`${designation}-${idx}`} className="group">
                  <div className={`bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl
                                   transition-all duration-300 border-2 ${designationColors[designation].border}
                                   hover:scale-[1.02]`}>
                    <div className="relative h-72 sm:h-80 md:h-96 overflow-hidden bg-gray-100">
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent z-10"></div>
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute bottom-0 left-0 right-0 z-20 p-4 sm:p-5 md:p-6">
                        <h4 className="text-white text-lg sm:text-xl md:text-2xl font-black mb-2 uppercase">
                          {member.name}
                        </h4>
                        <div className="flex items-center gap-2">
                          <div className="w-8 sm:w-10 h-0.5 bg-white/70"></div>
                          <p className="text-gray-200 font-light text-xs sm:text-sm uppercase tracking-wide">
                            {member.designation}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="p-4 sm:p-5 bg-gradient-to-br from-white to-gray-50/50">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <div className={`w-2 h-2 rounded-full ${designationColors[designation].dot}`}></div>
                          <span className="text-xs sm:text-sm font-black text-gray-600 uppercase">
                            {selectedDistrict}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ));
            })}
          </div>
        )}

        {/* No Members Found */}
        {selectedDistrict && sortedDistrictMembers.length === 0 && (
          <div className="text-center py-12 sm:py-16 pb-48 sm:pb-60">
            <div className="inline-block p-8 sm:p-10 md:p-12 bg-white rounded-2xl shadow-lg border border-gray-100">
              <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 bg-gray-100 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 sm:w-10 sm:h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-lg sm:text-xl font-black text-gray-700 mb-2 uppercase">No Members Available</h3>
              <p className="text-gray-500 text-sm sm:text-base font-light">
                Committee information for {selectedDistrict} will be updated soon.
              </p>
            </div>
          </div>
        )}

        {/* Initial State */}
        {!selectedDistrict && (
          <div className="text-center py-12 sm:py-16 pb-48 sm:pb-60">
            <div className="inline-block p-8 sm:p-10 md:p-12 bg-white rounded-2xl shadow-lg border border-gray-100">
              <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 bg-gray-50 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 sm:w-10 sm:h-10 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
              </div>
              <h3 className="text-lg sm:text-xl font-black text-gray-700 mb-2 uppercase">Select a District</h3>
              <p className="text-gray-500 text-sm sm:text-base font-light">
                Choose a district from the dropdown to view committee members
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Districtcommitie;

// working 24/03/26


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const Districtcommitie = () => {
//   const [selectedDistrict, setSelectedDistrict] = useState('');
//   const [districtMembers, setDistrictMembers] = useState([]);
//   const [allDistrictMembers, setAllDistrictMembers] = useState([]);

//   const districts = [
//     "Srikakulam",
//     "Vizianagram",
//     "Visakhapatnam",
//     "Kakinada",
//     "East Godavari",
//     "Konaseema",
//     "West Godavari",
//     "Eluru",
//     "Vijayawada",
//     "Krishna",
//     "Guntur",
//     "Palnadu",
//     "Bapatla",
//     "Prakasam",
//     "Nellore",
//     "Nandayala",
//     "Kurnool",
//     "Anantapur",
//     "Sri Sathyasai",
//     "Kadapa",
//     "Annamayya",
//     "Tirupati",
//     "Chittoor"
//   ];

//   const designationOrder = [
//     "President", "Secretary", "Treasurer"
//   ];

//   const designationColors = {
//     President: {
//       badge: "bg-emerald-500",
//       dot: "bg-emerald-500"
//     },
//     Secretary: {
//       badge: "bg-emerald-500",
//       dot: "bg-emerald-500"
//     },
//     Treasurer: {
//       badge: "bg-emerald-500",
//       dot: "bg-emerald-500"
//     }
//   };

//   useEffect(() => {
//     fetchAllDistrictMembers();
//   }, []);

//   const fetchAllDistrictMembers = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const res = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/district-committee`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setAllDistrictMembers(res.data);
//     } catch (error) {
//       console.error("Error fetching district committee members:", error);
//     }
//   };

//   const handleDistrictChange = (e) => {
//     const district = e.target.value;
//     setSelectedDistrict(district);

//     const members = allDistrictMembers.filter((member) => member.district === district);
//     setDistrictMembers(members);
//   };

//   const normalizeDesignation = (designation) => {
//     if (!designation) return 'Member';
//     const normalized = designation.trim().toLowerCase();

//     switch (normalized) {
//       case 'president':
//         return 'President';
//       case 'secretary':
//         return 'Secretary';
//       case 'treasurer':
//         return 'Treasurer';
//       default:
//         return 'Member';
//     }
//   };

//   const sortByDesignationOrder = (members) => {
//     return members.sort((a, b) => {
//       const aDesignation = normalizeDesignation(a.designation);
//       const bDesignation = normalizeDesignation(b.designation);
//       return designationOrder.indexOf(aDesignation) - designationOrder.indexOf(bDesignation);
//     });
//   };

//   const categorizeMembers = (members) => {
//     const categories = {
//       President: [],
//       Secretary: [],
//       Treasurer: [],
//     };

//     members.forEach((member) => {
//       const designation = normalizeDesignation(member.designation);
//       if (categories[designation]) {
//         categories[designation].push(member);
//       }
//     });

//     return categories;
//   };

//   const sortedDistrictMembers = sortByDesignationOrder(districtMembers);
//   const districtCategories = categorizeMembers(sortedDistrictMembers);

//   return (
//     <div className='min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50/30'>
//       {/* Hero Section */}
//       <section className="relative w-full h-[55vh] md:h-[75vh] overflow-hidden">
//         <img
//           src="/images/mosque4.jpg"
//           alt="Mosque"
//           className="w-full h-full object-cover"
//         />
//         <div className="absolute inset-0 bg-black/60 z-10"></div>
        
//         <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center px-4 sm:px-6">
//           <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black mb-4 tracking-tight uppercase">
//             District Committee
//           </h1>
//           <div className="w-20 sm:w-24 h-1 bg-black/90 mb-4 sm:mb-6"></div>
//           <p className="text-gray-50 max-w-2xl text-sm sm:text-base md:text-lg font-light leading-relaxed">
//             Meet our dedicated leaders serving the community with excellence
//           </p>
//         </div>
//       </section>

//       {/* Main Content */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-12 sm:py-16 md:py-20">
        
//         {/* District Selector */}
//         <div className="mb-12 sm:mb-16">
//           <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 md:p-10 border border-gray-100">
//             <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8">
              
//               <div className="text-center md:text-left">
//                 <h2 className="text-xl sm:text-2xl md:text-3xl font-black text-gray-800 mb-2 uppercase">
//                   Select District
//                 </h2>
//                 <p className="text-gray-600 text-xs sm:text-sm font-light">Choose a district to view committee members</p>
//               </div>

//               <div className="w-full md:w-auto md:min-w-[280px] lg:min-w-[320px]">
//                 <select
//                   value={selectedDistrict}
//                   onChange={handleDistrictChange}
//                   className="w-full px-4 sm:px-6 py-3 sm:py-3.5 rounded-xl font-black text-sm sm:text-base text-gray-700 bg-gray-50
//                              border-2 border-gray-200 shadow-sm appearance-none cursor-pointer
//                              hover:border-gray-400 focus:outline-none focus:border-gray-500 
//                              focus:ring-4 focus:ring-gray-100 transition-all duration-200"
//                   style={{
//                     backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23059669'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
//                     backgroundRepeat: 'no-repeat',
//                     backgroundPosition: 'right 1rem center',
//                     backgroundSize: '1.25em 1.25em',
//                     paddingRight: '3rem'
//                   }}
//                 >
//                   <option value="">Choose District</option>
//                   {districts.map((district) => (
//                     <option key={district} value={district}>
//                       {district}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Committee Members Grid */}
//         {selectedDistrict && sortedDistrictMembers.length > 0 && (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 md:gap-10 pb-60 sm:pb-80">
//             {designationOrder.map((designation) => {
//               const members = districtCategories[designation];
//               if (!members || members.length === 0) return null;

//               return members.map((member, idx) => (
//                 <div
//                   key={`${designation}-${idx}`}
//                   className="group"
//                 >
//                   <div className={`bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl 
//                                    transition-all duration-300 border-2 ${designationColors[designation].border}
//                                    hover:scale-[1.02]`}>
                    
//                     <div className="relative h-72 sm:h-80 md:h-96 overflow-hidden bg-gray-100">
//                       <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent z-10"></div>
//                       <img
//                         src={member.image}
//                         alt={member.name}
//                         className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
//                       />

//                       <div className="absolute bottom-0 left-0 right-0 z-20 p-4 sm:p-5 md:p-6">
//                         <h4 className="text-white text-lg sm:text-xl md:text-2xl font-black mb-2 uppercase">
//                           {member.name}
//                         </h4>
//                         <div className="flex items-center gap-2">
//                           <div className="w-8 sm:w-10 h-0.5 bg-white/70"></div>
//                           <p className="text-gray-200 font-light text-xs sm:text-sm uppercase tracking-wide">
//                             {member.designation}
//                           </p>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="p-4 sm:p-5 bg-gradient-to-br from-white to-gray-50/50">
//                       <div className="flex items-center justify-between">
//                         <div className="flex items-center gap-2">
//                           <div className={`w-2 h-2 rounded-full ${designationColors[designation].dot}`}></div>
//                           <span className="text-xs sm:text-sm font-black text-gray-600 uppercase">
//                             {selectedDistrict}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ));
//             })}
//           </div>
//         )}

//         {/* No Members Found */}
//         {selectedDistrict && sortedDistrictMembers.length === 0 && (
//           <div className="text-center py-12 sm:py-16 pb-48 sm:pb-60">
//             <div className="inline-block p-8 sm:p-10 md:p-12 bg-white rounded-2xl shadow-lg border border-gray-100">
//               <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 bg-gray-100 rounded-full flex items-center justify-center">
//                 <svg className="w-8 h-8 sm:w-10 sm:h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
//                 </svg>
//               </div>
//               <h3 className="text-lg sm:text-xl font-black text-gray-700 mb-2 uppercase">No Members Available</h3>
//               <p className="text-gray-500 text-sm sm:text-base font-light">
//                 Committee information for {selectedDistrict} will be updated soon.
//               </p>
//             </div>
//           </div>
//         )}

//         {/* Initial State */}
//         {!selectedDistrict && (
//           <div className="text-center py-12 sm:py-16 pb-48 sm:pb-60">
//             <div className="inline-block p-8 sm:p-10 md:p-12 bg-white rounded-2xl shadow-lg border border-gray-100">
//               <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 bg-gray-50 rounded-full flex items-center justify-center">
//                 <svg className="w-8 h-8 sm:w-10 sm:h-10 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
//                 </svg>
//               </div>
//               <h3 className="text-lg sm:text-xl font-black text-gray-700 mb-2 uppercase">Select a District</h3>
//               <p className="text-gray-500 text-sm sm:text-base font-light">
//                 Choose a district from the dropdown to view committee members
//               </p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Districtcommitie;



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const Districtcommitie = () => {
//   const [selectedDistrict, setSelectedDistrict] = useState('');
//   const [districtMembers, setDistrictMembers] = useState([]);
//   const [allDistrictMembers, setAllDistrictMembers] = useState([]);

//   const districts = [
//     "Srikakulam",
//     "Vizianagram",
//     "Visakhapatnam",
//     "Kakinada",
//     "East Godavari",
//     "Konaseema",
//     "West Godavari",
//     "Eluru",
//     "Vijayawada",
//     "Krishna",
//     "Guntur",
//     "Palnadu",
//     "Bapatla",
//     "Prakasam",
//     "Nellore",
//     "Nandayala",
//     "Kurnool",
//     "Anantapur",
//     "Sri Sathyasai",
//     "Kadapa",
//     "Annamayya",
//     "Tirupati",
//     "Chittoor"
//   ];

//   const designationOrder = [
//     "President", "Secretary", "Treasurer"
//   ];

//   const designationColors = {
//     President: {
//       badge: "bg-emerald-500",
//       dot: "bg-emerald-500"
//     },
//     Secretary: {
//       badge: "bg-emerald-500",
//       dot: "bg-emerald-500"
//     },
//     Treasurer: {
//       badge: "bg-emerald-500",
//       dot: "bg-emerald-500"
//     }
//   };

//   useEffect(() => {
//     fetchAllDistrictMembers();
//   }, []);

//   const fetchAllDistrictMembers = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const res = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/district-committee`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setAllDistrictMembers(res.data);
//     } catch (error) {
//       console.error("Error fetching district committee members:", error);
//     }
//   };

//   const handleDistrictChange = (e) => {
//     const district = e.target.value;
//     setSelectedDistrict(district);

//     const members = allDistrictMembers.filter((member) => member.district === district);
//     setDistrictMembers(members);
//   };

//   const normalizeDesignation = (designation) => {
//     if (!designation) return 'Member';
//     const normalized = designation.trim().toLowerCase();

//     switch (normalized) {
//       case 'president':
//         return 'President';
//       case 'secretary':
//         return 'Secretary';
//       case 'treasurer':
//         return 'Treasurer';
//       default:
//         return 'Member';
//     }
//   };

//   const sortByDesignationOrder = (members) => {
//     return members.sort((a, b) => {
//       const aDesignation = normalizeDesignation(a.designation);
//       const bDesignation = normalizeDesignation(b.designation);
//       return designationOrder.indexOf(aDesignation) - designationOrder.indexOf(bDesignation);
//     });
//   };

//   const categorizeMembers = (members) => {
//     const categories = {
//       President: [],
//       Secretary: [],
//       Treasurer: [],
//     };

//     members.forEach((member) => {
//       const designation = normalizeDesignation(member.designation);
//       if (categories[designation]) {
//         categories[designation].push(member);
//       }
//     });

//     return categories;
//   };

//   const sortedDistrictMembers = sortByDesignationOrder(districtMembers);
//   const districtCategories = categorizeMembers(sortedDistrictMembers);

//   return (
//     <div className='min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50/30'>
//     {/* Hero Section */}
// <section className="relative w-full h-[55vh] md:h-[75vh] overflow-hidden">
//   {/* Background Image */}
//   <img
//     src="/images/mosque4.jpg"
//     alt="Mosque"
//     className="w-full h-full object-cover"
//   />

//   {/* Black Overlay Mask */}
//   <div className="absolute inset-0 bg-black/60 z-10"></div>

//   {/* Text Content */}
//   <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center px-4">
//     <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold mb-4 tracking-tight">
//       District Committee
//     </h1>
//     <div className="w-24 h-1 bg-black/90 mb-6"></div>
//     <p className="text-gray-50 max-w-2xl text-base md:text-lg font-light">
//       Meet our dedicated leaders serving the community with excellence
//     </p>
//   </div>
// </section>


//       {/* Main Content */}
//       <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-20">
        
//         {/* District Selector */}
//         <div className="mb-16">
//           <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 border border-gray-100">
//             <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8">
              
//               {/* Left: Title */}
//               <div className="text-center md:text-left">
//                 <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
//                   Select District
//                 </h2>
//                 <p className="text-gray-600 text-sm">Choose a district to view committee members</p>
//               </div>

//               {/* Right: Dropdown */}
//               <div className="w-full md:w-auto md:min-w-[320px]">
//                 <select
//                   value={selectedDistrict}
//                   onChange={handleDistrictChange}
//                   className="w-full px-6 py-3.5 rounded-xl font-medium text-gray-700 bg-gray-50
//                              border-2 border-gray-200 shadow-sm appearance-none cursor-pointer
//                              hover:border-gray-400 focus:outline-none focus:border-gray-500 
//                              focus:ring-4 focus:ring-gray-100 transition-all duration-200 text-base"
//                   style={{
//                     backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23059669'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
//                     backgroundRepeat: 'no-repeat',
//                     backgroundPosition: 'right 1rem center',
//                     backgroundSize: '1.25em 1.25em',
//                     paddingRight: '3rem'
//                   }}
//                 >
//                   <option value="">Choose District</option>
//                   {districts.map((district) => (
//                     <option key={district} value={district}>
//                       {district}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

          
//           </div>
//         </div>

//         {/* Committee Members Grid */}
//         {selectedDistrict && sortedDistrictMembers.length > 0 && (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 pb-80">
//             {designationOrder.map((designation) => {
//               const members = districtCategories[designation];
//               if (!members || members.length === 0) return null;

//               return members.map((member, idx) => (
//                 <div
//                   key={`${designation}-${idx}`}
//                   className="group"
//                 >
//                   <div className={`bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl 
//                                    transition-all duration-300 border-2 ${designationColors[designation].border}
//                                    hover:scale-[1.02]`}>
                    
//                     {/* Image Container */}
//                     <div className="relative h-80 md:h-96 overflow-hidden bg-gray-100">
//                       <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent z-10"></div>
//                       <img
//                         src={member.image}
//                         alt={member.name}
//                         className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
//                       />
                      
//                       {/* Designation Badge */}
//                       {/* <div className="absolute top-5 right-5 z-20">
//                         <div className={`${designationColors[designation].badge} px-4 py-2 rounded-full shadow-lg`}>
//                           <span className="text-white font-semibold text-sm">
//                             {designation}
//                           </span>
//                         </div>
//                       </div> */}

//                       {/* Name on Image */}
//                       <div className="absolute bottom-0 left-0 right-0 z-20 p-6">
//                         <h4 className="text-white text-xl md:text-2xl font-bold mb-2">
//                           {member.name}
//                         </h4>
//                         <div className="flex items-center gap-2">
//                           <div className="w-10 h-0.5 bg-white/70"></div>
//                           <p className="text-gray-200 font-medium text-sm uppercase tracking-wide">
//                             {member.designation}
//                           </p>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Info Footer */}
//                     <div className="p-5 bg-gradient-to-br from-white to-gray-50/50">
//                       <div className="flex items-center justify-between">
//                         <div className="flex items-center gap-2">
//                           <div className={`w-2 h-2 rounded-full ${designationColors[designation].dot}`}></div>
//                           <span className="text-sm font-medium text-gray-600">
//                             {selectedDistrict}
//                           </span>
//                         </div>
                     
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ));
//             })}
//           </div>
//         )}

//         {/* No Members Found */}
//         {selectedDistrict && sortedDistrictMembers.length === 0 && (
//           <div className="text-center py-16 pb-60 ">
//             <div className="inline-block p-12 bg-white rounded-2xl shadow-lg border border-gray-100">
//               <div className="w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
//                 <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold text-gray-700 mb-2">No Members Available</h3>
//               <p className="text-gray-500">
//                 Committee information for {selectedDistrict} will be updated soon.
//               </p>
//             </div>
//           </div>
//         )}

//         {/* Initial State */}
//         {!selectedDistrict && (
//           <div className="text-center py-16 pb-60">
//             <div className="inline-block p-12 bg-white rounded-2xl shadow-lg border border-gray-100">
//               <div className="w-20 h-20 mx-auto mb-6 bg-gray-50 rounded-full flex items-center justify-center">
//                 <svg className="w-10 h-10 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold text-gray-700 mb-2">Select a District</h3>
//               <p className="text-gray-500">
//                 Choose a district from the dropdown to view committee members
//               </p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Districtcommitie;








// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const Districtcommitie = () => {
//   const [selectedDistrict, setSelectedDistrict] = useState('');
//   const [districtMembers, setDistrictMembers] = useState([]);
//   const [allDistrictMembers, setAllDistrictMembers] = useState([]);

//   // const districts = [
//   //   "Srikakulam", "Vizianagram", "Visakhapatnam", "Kakinada", "East Godavari",
//   //   "Konaseema", "West Godavari", "Eluru", "Vijayawada", "Krishna",
//   //   "Guntur", "Palnadu", "Bapatla", "Prakasam", "Nellore",
//   //   "Nandayala", "Kurnool", "Anantapur", "SriSathyasai", "Kadapa",
//   //   "Annamayya", "TIRUPATI", "CHITTOOR"
//   // ];
//   const districts = [
//   "Srikakulam",
//   "Vizianagram",
//   "Visakhapatnam",
//   "Kakinada",
//   "East Godavari",
//   "Konaseema",
//   "West Godavari",
//   "Eluru",
//   "Vijayawada",
//   "Krishna",
//   "Guntur",
//   "Palnadu",
//   "Bapatla",
//   "Prakasam",
//   "Nellore",
//   "Nandayala",
//   "Kurnool",
//   "Anantapur",
//   "Sri Sathyasai",
//   "Kadapa",
//   "Annamayya",
//   "Tirupati",
//   "Chittoor"
// ];


//   // Only showing President, Secretary, and Treasurer
//   const designationOrder = [
//     "President", "Secretary", "Treasurer"
//   ];

//   useEffect(() => {
//     fetchAllDistrictMembers();
//   }, []);

//   const fetchAllDistrictMembers = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const res = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/district-committee`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setAllDistrictMembers(res.data);
//     } catch (error) {
//       console.error("Error fetching district committee members:", error);
//     }
//   };

//   const handleDistrictChange = (e) => {
//     const district = e.target.value;
//     setSelectedDistrict(district);

//     const members = allDistrictMembers.filter((member) => member.district === district);
//     setDistrictMembers(members);
//   };

//   const normalizeDesignation = (designation) => {
//     if (!designation) return 'Member';
//     const normalized = designation.trim().toLowerCase();

//     switch (normalized) {
//       case 'president':
//         return 'President';
//       case 'secretary':
//         return 'Secretary';
//       case 'treasurer':
//         return 'Treasurer';
     
//     }
//   };

//   const sortByDesignationOrder = (members) => {
//     return members.sort((a, b) => {
//       const aDesignation = normalizeDesignation(a.designation);
//       const bDesignation = normalizeDesignation(b.designation);
//       return designationOrder.indexOf(aDesignation) - designationOrder.indexOf(bDesignation);
//     });
//   };

//   const categorizeMembers = (members) => {
//     const categories = {
//       President: [],
//       Secretary: [],
//       Treasurer: [],
//     };

//     members.forEach((member) => {
//       const designation = normalizeDesignation(member.designation);
//       if (categories[designation]) {
//         categories[designation].push(member);
//       }
//     });

//     return categories;
//   };

//   const sortedDistrictMembers = sortByDesignationOrder(districtMembers);
//   const districtCategories = categorizeMembers(sortedDistrictMembers);

//   return (
//     <div className='pb-[600px] md:pb-[320px] lg:pb-[420px]'>
//       {/* Hero Section */}
//       <section className="relative w-full h-[500px] md:h-[700px]">
//         <img
//           src="/images/mosque4.jpg"
//           alt="Mosque"
//           className="w-full h-full object-cover brightness-75"
//         />
//         <div className="absolute inset-0 bg-black opacity-40"></div>
//         <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
//           <h1 className="text-white text-3xl md:text-6xl font-bold mb-4 drop-shadow-lg">
//             Our Dedicated Members
//           </h1>
//           <p className="text-white max-w-2xl text-base md:text-xl drop-shadow-md">
//             United by a shared vision, our Committee Members work tirelessly to lead, inspire, and uplift our community.
//           </p>
//         </div>
//       </section>

//       {/* Select District */}
//       <div className="py-10 px-4 md:px-10 min-h-screen">
//         <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-10">
//         <h1 className=' text-gray-800 text-4xl font-semibold'>Please Select District</h1>
//           <select
//             value={selectedDistrict}
//             onChange={handleDistrictChange}
//             className="px-6 md:px-10 py-2 rounded-full font-semibold bg-white text-gray-800 border border-gray-600 w-full md:w-auto text-center"
//           >
//             <option value="">Select District </option>
//             {districts.map((district) => (
//               <option key={district} value={district}>
//                 {district}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* District Members */}
//         {selectedDistrict && (
//           <div className="w-full">
//             <h2 className="text-2xl md:text-4xl font-bold mb-10 text-center text-gray-800">{selectedDistrict} Committee</h2>

//             {designationOrder.map((category, index) => (
//               districtCategories[category] && districtCategories[category].length > 0 && (
//                 <Category key={index} title={category} members={districtCategories[category]} />
//               )
//             ))}
//           </div>
//         )}

//         {/* No Members */}
//         {selectedDistrict && sortedDistrictMembers.length === 0 && (
//           <p className="text-gray-500 text-center mt-8">No members found for this district.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// const Category = ({ title, members }) => (
//   <div className="mb-16">
//     <h3 className="text-2xl md:text-4xl text-gray-800 mb-8 text-center">{title}</h3>
//     <div className="flex flex-wrap justify-center gap-8 md:gap-12">
//       {members.map((member, idx) => (
//         <div
//           key={idx}
//           className="relative bg-white rounded-lg shadow-md overflow-visible w-72 md:w-64 hover:shadow-xl transition"
//         >
//           <img
//             src={member.image}
//             alt={member.name}
//             className="w-full h-72 object-cover rounded-t-lg"
//           />
//           <div className="absolute left-1/2 transform -translate-x-1/2 translate-y-1/2 bottom-0 bg-white text-black w-48 md:w-44 px-4 text-center py-3 rounded-md shadow-md z-10">
//             <h4 className="text-md font-semibold border-b-2 border-gray-200 mb-2">{member.name}</h4>
//             <p className="text-sm">{member.designation}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// );

// export default Districtcommitie;


